import React from "react";
import { TonConnectUIProvider } from "@tonconnect/ui-react";

const TonConnectProvider = ({ children }) => {
  const manifestUrl = `${window.location.origin}/tonconnect-manifest.json`;

  return (
    <TonConnectUIProvider
      manifestUrl={manifestUrl}
      actionsConfiguration={{
        twaReturnUrl: "https://t.me/CGPEERSSITE_BOT",
      }}
    >
      {children}
    </TonConnectUIProvider>
  );
};

export default TonConnectProvider;
